module.exports = {"371082001":"宁津街道","371082002":"港湾街道","371082003":"桃园街道","371082004":"王连街道","371082005":"东山街道","371082006":"斥山街道","371082007":"崖头街道","371082008":"城西街道","371082009":"寻山街道","371082010":"崂山街道","371082101":"俚岛镇","371082102":"成山镇","371082103":"埠柳镇","371082104":"港西镇","371082105":"夏庄镇","371082106":"崖西镇","371082107":"荫子镇","371082108":"滕家镇","371082109":"大疃镇","371082110":"上庄镇","371082111":"虎山镇","371082112":"人和镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371082.json
// module id = 1566
// module chunks = 0